enum Mode {
	import = "import",
	clone = "clone",
	init = "init",
}

export default Mode;
